/**
 * The periods a report's relative date filters accept.
 *
 * These lists are what the filter dropdowns are built from, and they are also sent to the AI report
 * builder so it can only ask for a period the tool can actually show. They live here rather than
 * inside filter-field-value-directive because two places now depend on them being the same, and a
 * builder that offered "QUARTER" would produce a filter whose dropdown sits empty.
 *
 * Note the two shapes: "LAST X" takes a singular period, "LAST N X" takes a count and a plural one.
 */
export const REPORT_FILTER_PERIODS = {
  /** For LAST X, THIS X, NEXT X - the whole current or previous period. */
  single: ["DAY", "WEEK", "MONTH", "YEAR"],
  /** For LAST N X, NEXT N X - a count of periods. */
  counted: ["DAYS", "WEEKS", "MONTHS", "YEARS"],
  /** For LAST REL N X, NEXT REL N X - relative to now, finer grained. */
  relative: ["MINUTES", "HOURS", "DAYS"]
};

export const REPORT_FILTER_PERIOD_OPERATORS = {
  single: ["LAST X", "THIS X", "NEXT X"],
  counted: ["LAST N X", "NEXT N X"],
  relative: ["LAST REL N X", "NEXT REL N X"]
};
